import React, { useEffect, useState } from "react";

const filterButtonsData = [
  { status: "critical", icon: "critical-icon.svg", label: "Critical" },
  { status: "warning", icon: "warning-icon.svg", label: "Warning" },
  // { status: "info", icon: "info-icon.svg", label: "Info" },
];

const AlarmCard = ({
  selectAlarm,
  data,
  toggleExpandGroup,
  isExpanded,
  isExpandable,
  id,
  acknowledgeAlarm,
  closeAllAlarm,
  closeAlarm,
  count,
}) => {
  function formatTime(timestamp) {
    const date = new Date(timestamp);
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    const day = date.getDate();
    const monthIndex = date.getMonth();
    const year = date.getFullYear();
    let hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();
    const ampm = hours >= 12 ? "PM" : "AM";
    if (hours > 12) {
      hours -= 12;
    } else if (hours === 0) {
      hours = 12;
    }
    return `${day}-${months[monthIndex]}-${year} ${hours}:${
      minutes < 10 ? "0" + minutes : minutes
    }:${seconds < 10 ? "0" + seconds : seconds} ${ampm}`;
  }

  return (
    <div className="Card border-2 mb-2 cursor-pointer border-neutral-700 mr-1 pt-2 pb-1 h-auto flex-col relative rounded-lg">
      <div className="flex justify-between items-center rounded-t-lg px-5 mb-3">
        <div className="text-white font-semibold text-base">
          {data.camId}
          <label className="text-neutral-500 ml-3 text-lg font-medium">
            |
            {isExpandable && (
              <label className=" bg-zinc-900 text-white text-xs w-24 h-6 px-5 py-1 rounded-lg ml-3">
                {count}&nbsp; Alarms
              </label>
            )}
          </label>
        </div>
        {/* <button
          type="button"
          className="text-white font-medium text-xs w-5 h-5"
        >
          <img src="drop-arrow-icon.svg" className="rotate-180" />
        </button> */}
      </div>
      <div>
        <div
          className={`flex justify-between transition-all ease-in-out duration-300 bg-zinc-900 mb-2 pt-2 mx-2 rounded-lg border ${
            data.status === "critical" ? "border-red-600" : "border-orange-600"
          }`}
        >
          <div className="text-gray-500 dark:text-gray-400 w-full text-xs font-semibold">
            <div className="flex flex-col  px-4 py-2 ">
              <div className="flex items-center gap-2 justify-between w-full h-11">
                <div className="flex gap-2">
                  <div className="h-6 w-6 bg-black rounded-full text-xs text-white flex items-center justify-center">
                    1
                  </div>
                  <div className="w-fit flex items-center gap-3 text-white text-sm font-medium">
                    {data.name}
                  </div>
                </div>
                <div className="w-7 h-full flex flex-col items-center">
                  {data.status === "critical" ? (
                    <div className="border-red-600 rounded-full w-7 h-7 flex justify-center items-center border">
                      <img src="critical-icon.svg" alt="Severity Icon" />
                    </div>
                  ) : (
                    <div className="border-orange-600 rounded-full w-7 h-7 flex justify-center items-center border">
                      <img src="warning-icon.svg" alt="Severity Icon" />
                    </div>
                  )}
                </div>
              </div>
              <div className="flex flex-col font-semibold text-xs py-1 pb-3">
                <div className="text-white">
                  <span className="text-neutral-500">
                    Reported Time&nbsp;&nbsp;&nbsp;:&nbsp;&nbsp;&nbsp;
                  </span>
                  {formatTime(data.time)}
                </div>
              </div>
            </div>
            <div className="">
              <hr className="border-neutral-600 font-bold text-lg" />
            </div>
            <div className="w-full flex justify-between gap-1 px-3 text-xs my-3 ">
              <div>
                {isExpandable ? (
                  <button
                    type="button"
                    className="border-neutral-500 border-2 gap-2 text-white h-8 rounded-3xl text-center w-28 flex items-center justify-center disabled:opacity-25"
                    onClick={() => toggleExpandGroup(id)}
                  >
                    {count - 1}&nbsp;more
                    {isExpanded ? (
                      <img src="drop-arrow-icon.svg" className="rotate-180" />
                    ) : (
                      <img src="drop-arrow-icon.svg" />
                    )}
                  </button>
                ) : (
                  <button
                    type="button"
                    className="border-neutral-500 border-2 gap-2 text-white h-8 rounded-3xl text-center w-28 flex items-center justify-center disabled:opacity-25"
                    onClick={() => selectAlarm(data)}
                  >
                    <img
                      className="invert w-5 h-5"
                      src="image_icon.png"
                      alt="icon"
                    />
                    VIew Image
                  </button>
                )}
              </div>
              {/* {data.acknowledged ? ( */}
              {isExpandable ? (
                <button
                  type="button"
                  onClick={() => closeAllAlarm(data)}
                  className="border-2 h-8 rounded-3xl text-center w-36 border-white text-white justify-center flex gap-1 items-center disabled:opacity-25"
                >
                  <span>Close All</span>
                </button>
              ) : (
                <button
                  type="button"
                  onClick={() => closeAlarm(data)}
                  className="border-2 h-8 rounded-3xl text-center w-36 border-neutral-500 text-white justify-center flex gap-1 items-center disabled:opacity-25"
                >
                  <span>Close</span>
                </button>
              )}
              {/* ) : ( */}
              {/* <button
                  type="button"
                  onClick={() => {
                    !isExpandable ? acknowledgeAlarm(data) : selectAlarm(data);
                  }}
                  className="border-2 h-8 rounded-3xl text-center w-36 border-lime-600 text-lime-600 justify-center flex gap-1 items-center disabled:opacity-25"
                >
                  <img src="Acknowledge-icon.svg" />
                  {isExpandable ? (
                    <span>Acknowledge All</span>
                  ) : (
                    <span>Acknowledge</span>
                  )}
                </button>
              )} */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const AlarmList = ({ selectAlarm, setOpen, open, alarms, setAlarms }) => {
  const [groupedAlarms, setGroupedAlarms] = useState();
  const [expandedGroups, setExpandedGroups] = useState([]);

  const [filterOptions, setFilterOptions] = useState({
    filtered: false,
    previousKey: null,
    currentKey: null,
  });
  useEffect(() => {
    if (filterOptions.currentKey) {
      const filteredData = alarms.filter(
        (a) => a.status === filterOptions.currentKey
      );
      setGroupedAlarms(groupAlarms(filteredData));
    } else {
      setGroupedAlarms(groupAlarms(alarms));
    }
    // setGroupedAlarms(groupAlarms(alarms));
  }, [alarms]);

  const handleFilterClick = (filterKey) => {
    if (
      filterOptions.filtered &&
      filterOptions.previousKey !== null &&
      filterOptions.previousKey === filterKey
    ) {
      // Reset to original grouped alarms when the same filter is clicked again
      setGroupedAlarms(groupAlarms(alarms));
      setFilterOptions({ filtered: false, previousKey: null, currentKey: "" });
    } else {
      // Filter the alarms based on the selected status
      const filteredData = alarms.filter((a) => a.status === filterKey);
      // Regroup the filtered alarms by status and camId
      const groupedFilteredData = groupAlarms(filteredData);
      setGroupedAlarms(groupedFilteredData);
      setFilterOptions({
        filtered: true,
        previousKey: filterKey,
        currentKey: filterKey,
      });
    }
  };
  const closeAlarm = (closedAlarm) => {
    // Filter out the closed alarm from alarms state
    const updatedAlarms = alarms.filter((alarm) => alarm !== closedAlarm);
    setAlarms(updatedAlarms);
    groupAlarms(updatedAlarms);
  };
  const closeAllAlarm = (closedAlarm) => {
    // Filter out the alarms with the same camId, name, and status as the closedAlarm
    const updatedAlarms = alarms.filter(
      (alarm) =>
        alarm.camId !== closedAlarm.camId ||
        alarm.name !== closedAlarm.name ||
        alarm.status !== closedAlarm.status
    );
    setAlarms(updatedAlarms);
    // Regroup the alarms after filtering
    setGroupedAlarms(groupAlarms(updatedAlarms));
  };

  const acknowledgeAlarm = (alarm) => {
    const updatedAcknowledgedAlarms = alarms.map((a) => {
      if (a === alarm) {
        return { ...a, acknowledged: true };
      }
      return a;
    });
    setAlarms(updatedAcknowledgedAlarms);
    groupAlarms(updatedAcknowledgedAlarms);
  };
  function groupAlarms(alarms) {
    const groupedAlarms = {};

    // Iterate through each alarm
    alarms.forEach((alarm) => {
      const key = `${alarm.status}-${alarm.camId}`;

      // If the key doesn't exist in the groupedAlarms object, create it
      if (!groupedAlarms[key]) {
        groupedAlarms[key] = [];
      }

      // Push the alarm object to the corresponding key
      groupedAlarms[key].push(alarm);
    });
    return groupedAlarms;
  }
  const toggleExpandGroup = (key) => {
    console.log(key, "key");
    if (expandedGroups.includes(key)) {
      setExpandedGroups(expandedGroups.filter((groupKey) => groupKey !== key));
    } else {
      setExpandedGroups([...expandedGroups, key]);
    }
  };
  return (
    <div className="flex flex-col w-full h-full bg-neutral-950 overflow-y-auto rounded-t-lg duration-500 ease-in-out">
      <div className="flex px-6 py-2 items-center rounded-t-md justify-between bg-gradient-to-r from-red-800 to-orange-600">
        <div className="flex items-center gap-2 ">
          <label className="font-semibold text-sm text-gray-300 ">Alarms</label>
          <div className="flex bg-red-600 rounded-full h-8 min-w-[32px] px-1 justify-center items-center">
            <div className="bg-red-500 min-w-[24px] px-2 h-6 rounded-full text-white font-semibold text-xs flex justify-center items-center">
              {alarms.length}
            </div>
          </div>
        </div>
        <div className="h-5 rounded-lg flex items-center gap-4">
          <button
            type="button"
            className="border border-white flex items-center pr-3 gap-3 p-1 rounded-md"
          >
            <label className="text-xs text-white">All Alarms</label>
          </button>
          <button
            type="button"
            className="lg:flex hidden"
            onClick={() => setOpen(!open)}
          >
            <img src="Union.svg" alt="union" className="text-orange-300 " />
          </button>
        </div>
      </div>
      <div className=" bg-zinc-950 flex flex-col sticky top-0 z-20">
        <div className="flex justify-between w-full mr-1 items-center text-xs text-gray-300 font-normal gap-3 px-8 pr-9 sticky z-10 py-2 bg-zinc-800 top-2 bottom-2 mt-2 mb-2 border border-zinc-500 rounded-lg">
          {filterButtonsData.map((fbm, index) => (
            <button
              type="button"
              className={`flex items-center ${
                filterButtonsData.length === index + 1 ? "" : "border-r"
              }  border-neutral-600 pr-3`}
              onClick={() => handleFilterClick(fbm.status)}
              key={index}
            >
              <div
                className={`${
                  filterOptions.previousKey === fbm.status
                    ? " border-b-4 pb-2 border-white"
                    : "my-1"
                } flex gap-2 transition-all ease-in`}
              >
                <img src={fbm.icon} alt={fbm.status} />
                {fbm.label}&nbsp;(
                {alarms
                  ? alarms.filter((a) => a.status === fbm.status)?.length
                  : "0"}
                )
              </div>
            </button>
          ))}
        </div>
        <div id="alarms" className="space-y-2 py-2 h-[80vh] overflow-y-auto">
          {groupedAlarms &&
            Object.keys(groupedAlarms).map((key, index) => (
              <div key={index}>
                {/* Render the first alarm in the group */}
                <AlarmCard
                  selectAlarm={selectAlarm}
                  data={groupedAlarms[key][0]}
                  count={groupedAlarms[key].length}
                  toggleExpandGroup={toggleExpandGroup}
                  isExpandable={groupedAlarms[key].length > 1}
                  isExpanded={expandedGroups.includes(key)}
                  id={key}
                  closeAllAlarm={closeAllAlarm}
                />

                {/* Render remaining alarms in the group if expanded */}
                {expandedGroups.includes(key) &&
                  groupedAlarms[key]
                    .slice(1)
                    .map((alarm, subIndex) => (
                      <AlarmCard
                        key={`${index}-${subIndex}`}
                        selectAlarm={selectAlarm}
                        data={alarm}
                        acknowledgeAlarm={acknowledgeAlarm}
                        closeAlarm={closeAlarm}
                      />
                    ))}
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default AlarmList;
